export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1739_.5352a98b.jpg";